import { render, staticRenderFns } from "./AiYuigonBannerPlaceholder.vue?vue&type=template&id=81f179f2&scoped=true&"
import script from "./AiYuigonBannerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AiYuigonBannerPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AiYuigonBannerPlaceholder.vue?vue&type=style&index=0&id=81f179f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f179f2",
  null
  
)

export default component.exports